import types from '../actions/types';

const initial_state = {
    loading: false
}

export default function(state = initial_state, action) {
    switch (action.type) {
        case types.LOAD_SETTINGS.REQUEST:
            return {
                ...state,
                loading: true,
                settings: null
            };
        case types.LOAD_SETTINGS.SUCCESS:
            return {
                ...state,
                loading: false,
                settings: action.payload
            };
        case types.LOAD_SEASONS.FAILURE:
            return {
                ...state,
                loading: false,
                settings: null
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/settings.js